
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/order-status",
      function () {
        return require("private-next-pages/order-status.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/order-status"])
      });
    }
  